import { useMutation, UseMutationOptions, useQueryClient } from 'react-query';

import { photoTagsApi } from 'src/Services/API';

interface RemovePhotoTagParams {
  tagId: string;
  storageFileId: string;
  memberId: string;
}

export const useRemovePhotoTag = (
  options?: UseMutationOptions<void, unknown, RemovePhotoTagParams>
) => {
  const queryClient = useQueryClient();

  return useMutation<void, unknown, RemovePhotoTagParams>(
    'remove-photo-tag',
    async (data: RemovePhotoTagParams) => {
      await photoTagsApi.photoTagsControllerRemoveTag(data.tagId);
    },
    {
      ...options,
      onSuccess(data, variables, context) {
        queryClient.invalidateQueries(['fetch-photo-tags', variables.storageFileId]);
        queryClient.invalidateQueries(['fetch-member-photo-album', variables.memberId]);

        options?.onSuccess?.(data, variables, context);
      },
    }
  );
};
